import { ComingSoonPanel, IconOrgs, PageHeader } from '@shared/ui';

export function OrgsPage() {
    return (
        <>
            <PageHeader
                eyebrow="Tenants"
                title="Client Orgs"
                description="Every museum tenant, synced from the source of record. Drill in to see a tenant's effective flags and add-ons."
            />
            <ComingSoonPanel
                icon={<IconOrgs className="size-6" />}
                title="Tenant registry"
                blurb="The client-org list and the tenant-centric effective-flag view (override → add-on → default, with the winning source) land here in Phase 1."
            />
        </>
    );
}
